import { AfterViewInit, Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-budget-assessment',
  templateUrl: './budget-assessment.component.html',
  styles: [
    'span {font-weight: bold;}',
    'table {display:block; margin-bottom:1em}',
    '.mat-mdc-table {width: 100%;max-height: 500px;overflow: auto;}',
    'tr.element-row:hover{background: whitesmoke}',
	  'a {text-decoration: none;}',
    '.loading-shade {position: absolute;top: 0;left: 0;bottom: 56px;right: 0;background: rgba(136, 134, 134, 0.15);z-index: 1;display: flex;align-items: center;justify-content: center;}'
  ]
})

export class BudgetAssessmentComponent implements AfterViewInit {
  @ViewChild('paginatorPrimary') paginatorPrimary:MatPaginator;
  @ViewChild('paginatorCoApp') paginatorCoApp:MatPaginator;
  @Output() sendBudgetAssessment = new EventEmitter<any>();
  constructor(private apiService:LegacyApiService){}
  baColumns: string[] = ['name', 'province','agencyName', 'note'];
  dataSourcePrimaryBA:MatTableDataSource<string[]>;
  dataSourceCoAppBA:MatTableDataSource<string[]>;
  isLoading = true;
  totalBAPrimary:number;
  totalCoApp:number;
  serviceSubscription:Subscription;
  async ngAfterViewInit(): Promise<void> {
    this.dataSourcePrimaryBA = new MatTableDataSource(await this.budgetAssesment(['Budget Assessment']));
    this.dataSourcePrimaryBA.paginator=this.paginatorPrimary;
    this.dataSourceCoAppBA = new MatTableDataSource(await this.budgetAssesment(['Co-App Budget Assessment']));
    this.dataSourceCoAppBA.paginator=this.paginatorCoApp;
    this.totalBAPrimary = this.dataSourcePrimaryBA.filteredData?.map((item:any)=>item.Amount).reduce((prev,next)=>prev+next,0);
    this.totalCoApp = this.dataSourceCoAppBA.filteredData?.map((item:any)=>item.Amount).reduce((prev,next)=>prev+next,0);
    this.sendTotalCountandAmount((this.dataSourcePrimaryBA.filteredData.length+this.dataSourceCoAppBA.filteredData.length),(this.totalBAPrimary+this.totalCoApp));
  }
;
  budgetAssesment(stageName):Promise<any>{
    return new Promise((resolve,reject)=>{
      this.isLoading = true;
      this.serviceSubscription=this.apiService.underwritingDashboardQueues(stageName).subscribe((res:any) => {
        if (res.message.statusCode === 200) {
          const arr = JSON.parse(res.message.body);
          this.isLoading = false;
          resolve(arr.data);
        }else{
          this.isLoading = false;
          resolve([])
        }
      })
    })
    }

  sendTotalCountandAmount(count:number,amount:number){
    const result = {count:count,amount:amount};
    this.sendBudgetAssessment.emit(result);
  }

  ngOnDestroy() {
    this.serviceSubscription.unsubscribe();
  }

}
